export default {
  covid19_report_member_info: {
    'sequencing-quality-assessment': {
      name: '测序质量评估',
      render: false
    },
    'sequencing-assembly': {
      name: '序列组装',
      render: false
    },
    'mutation-distribution': {
      name: '突变位点分布',
      render: false
    },
    'classification-results': {
      name: 'Blast结果',
      render: false
    },
    'genotype-results': {
      name: '重组分析结果',
      render: false
    },
    'phylogenetic-tree-results': {
      name: '进化树结果',
      render: false
    },
    'resistance-results': {
      name: '耐药结果',
      render: false
    },
    'antigenic-drift-results': {
      name: '免疫逃逸结果',
      render: false
    },
    'virulence-results': {
      name: '毒力结果',
      render: false
    },
    'protein-conformation-results': {
      name: '蛋白构象结果',
      render: false
    },
    // 多序列分析结果
    'microbe-trace-results': {
      name: 'Trace分析结果',
      render: false
    },
    'temporal-rate-results': {
      name: '进化速率结果',
      render: false
    },
    'beast2-results': {
      name: '传播分析结果',
      render: false
    }
  },

  _covid19_lineage_info: [
    // { name: 'GH', country: 'Singapore,Thailand,Vietnam,Singapore', info: '为G型分化出的两个主要亚型之一, 除D614G变异，还ORF3a上包含Q57H变异' },
    // { name: 'G', country: 'Singapore,Thailand,Vietnam', info: '2019年早期出现的高传染力变异型，包含D614G变异，随后演化为多种高传染力毒株' },
    // { name: 'GR', country: 'Singapore,Thailand,Vietnam', info: 'G型分化出的两个主要型之一，并且后续有进一步分化。增加了NSP3上的RG203KR' },
    // { name: 'L', country: 'Indonesia,Malaysia,Singapore,Thailand', info: '接近早期武汉的毒株，比较原始' },
    // { name: 'O', country: 'Indonesia,Malaysia,Singapore', info: '未分类的outgroup，变异多样，可能与V型亲缘关系近' },
    // { name: 'S', country: 'Singapore,Thailand', info: 'G型毒株的原型' },
    // { name: 'V', country: 'Malaysia,Singapore,Thailand,Vietnam', info: '同为早期武汉出现的早期毒株，传播较少' },
    // { name: 'GV', country: 'England', info: '最早于2020年9月出现在西班牙，主要在欧洲传播' },
    // { name: 'GRY', country: 'England', info: '由GR型分化而来；为2020年在英国发现的变异型，包含N501Y等变异' }
    { name: 'A', type: '19B/S', date: '2019/12/30', count: 5, flag: '', snp: '', info: '有研究认为A系是病毒的祖先，主要包括武汉早期的样本，但在日韩和欧美均有发现。' },
    { name: 'A.23.1', type: '19B/S', date: '2020/10/21', count: 5, flag: '', snp: '', info: '国际间广泛传播，包括681R位置的变异值得关注。' },
    { name: 'AU.1', type: '20A/GH', date: '2021/1/1', count: 5, flag: '', snp: '', info: '与B.1.466.2.1是近缘关系,主要发现在新几内亚和澳大利亚。' },
    { name: 'AU.3', type: '20A/GH', date: '2021/2/9', count: 4, flag: '', snp: '', info: '与B.1.466.2.3是近缘关系,主要发现在新几内亚和新加坡。' },
    { name: 'B', type: '19A/L/O/V', date: '2019/12/24', count: 7, flag: '', snp: '', info: '新冠病毒最主要的大型分支' },
    { name: 'B.1', type: 'G', date: '2020/1/24', count: 46, flag: '', snp: '', info: '可能最早于2020年初来自意大利北部' },
    { name: 'B.1.1', type: '20B/GR', date: '2020/2/16', count: 32, flag: '', snp: '', info: '来自欧洲，包括28881G>A,28882G>A,28883G>C等特征变异' },
    { name: 'B.1.1.1', type: '20D/GR', date: '2020/3/2', count: 4, flag: '', snp: '', info: '来自英国' },
    { name: 'B.1.111', type: '20A/GH', date: '2020/3/7', count: 4, flag: '', snp: '', info: '来自中/南美，主要是哥伦比亚' },
    { name: 'B.1.1.214', type: '20B/GR', date: '2020/2/22', count: 3, flag: '', snp: '', info: '来自日本' },
    { name: 'B.1.1.28', type: '20B/GR', date: '2020/3/5', count: 4, flag: '', snp: '', info: '主要来自巴西' },
    { name: 'B.1.1.317', type: '20B/GR', date: '2020/2/28', count: 4, flag: '', snp: '', info: '来自俄罗斯' },
    { name: 'B.1.1.33', type: '20B/GR', date: '2020/3/1', count: 4, flag: '', snp: '', info: '主要来自巴西' },
    { name: 'B.1.1.348', type: '20B/GR', date: '2020/4/30', count: 6, flag: '', snp: '', info: '主要来自美国/南美' },
    { name: 'B.1.1.519', type: '20B/GR', date: '2020/11/1', count: 19, flag: '', snp: '', info: '主要来自美国/墨西哥' },
    { name: 'B.1.160', type: '20A/GH', date: '2020/2/6', count: 6, flag: '', snp: '', info: '大型谱系，来自欧洲' },
    { name: 'B.1.1.7', type: '20I/501Y.V1/G/GR/GRY', date: '2020/2/7', count: 171, flag: 'Alpha', snp: '69–70del, N501Y, P681H', info: '来自英国，包括重点关注的变异N501Y' },
    { name: 'B.1.177', type: '20E(EU1)/GV', date: '2020/2/14', count: 8, flag: '', snp: '', info: '来自欧洲，在夏季爆发' },
    { name: 'B.1.2', type: '20G/GH', date: '2020/2/2', count: 22, flag: '', snp: '', info: '来自美国' },
    { name: 'B.1.258', type: '20A/G', date: '2020/3/22', count: 6, flag: '', snp: '', info: '来自英国' },
    { name: 'B.1.351', type: '20H/501Y.V2/GH', date: '2020/3/27', count: 31, flag: 'Beta', snp: 'K417N, E484K, N501Y', info: '南非变异株，由英国传入' },
    { name: 'B.1.351.3', type: '20H/501Y.V2/GH', date: '2021/1/12', count: 4, flag: '', snp: '', info: '为B.1.351的变异亚株，主要发现在新加坡和孟加拉国' },
    { name: 'B.1.36', type: '20A/GH', date: '2020/2/16', count: 4, flag: '', snp: '', info: '全球分布' },
    { name: 'B.1.411', type: '20C/GH/O', date: '2020/3/23', count: 4, flag: '', snp: '', info: '主要来自斯里兰卡' },
    { name: 'B.1.429', type: '20C/GH', date: '2020/4/15', count: 7, flag: 'Epsilon', snp: 'L452R', info: '最早来自美国加州' },
    { name: 'B.1.466.2', type: '20A/GH', date: '2020/11/12', count: 5, flag: '', snp: '', info: '来自印尼' },
    { name: 'B.1.497', type: '20C/GH', date: '2020/5/5', count: 4, flag: '', snp: '', info: '来自韩国' },
    { name: 'B.1.525', type: '20A/G', date: '2020/12/11', count: 6, flag: 'Eta', snp: 'E484K, F888L', info: '全球分布，最早发现于尼日利亚，主要变异有E484K, del69-70' },
    { name: 'B.1.526', type: '20C/GH', date: '2020/4/21', count: 3, flag: '', snp: '', info: '最早在美国纽约大量传播，随后传播到其他地区，特征变异包括 T95I和D253G等。' },
    { name: 'B.1.617.1', type: '21A/G', date: '2020/12/1', count: 4, flag: 'Kappa', snp: 'L452R, E484Q, P681R', info: '印度毒株' },
    { name: 'B.1.617.2', type: '21A/G', date: '2020/9/7', count: 11, flag: 'Delta', snp: 'L452R, T478K, P681R', info: '印度毒株，突刺蛋白进一步变异' },
    { name: 'C.16', type: '20D/GR', date: '2020/6/26', count: 3, flag: '', snp: '', info: '欧洲地区传播，最早发现在葡萄牙' },
    { name: 'C.36', type: '20D/GR', date: '2020/3/13', count: 4, flag: '', snp: '', info: '主要在埃及传播' },
    { name: 'C.37', type: '20D/GR', date: '2020/8/25', count: 4, flag: '', snp: '', info: '主要在美国、智利、秘鲁和德国传播' },
    { name: 'D.2', type: '20B/GR', date: '2020/3/19', count: 4, flag: '', snp: '', info: '来自澳大利亚' },
    { name: 'P.1', type: '20J/501Y.V3/GR', date: '2020/4/7', count: 17, flag: 'Gamma', snp: 'K417T, E484K, N501Y', info: '来自巴西的变异毒株，特征变异包括E484K, K417T和N501Y' },
    { name: 'P.2', type: '20B/GR', date: '2020/4/13', count: 6, flag: '', snp: '', info: '巴西毒株' },
    { name: 'R.1', type: '20B/GR', date: '2020/2/1', count: 4, flag: '', snp: '', info: 'B.1.1.316.1的近缘毒株，多国传播' },
    { name: 'BA.1', type: '21K', date: '2021/11/20', count: 1, flag: 'Omicron', snp: 'S(H69del,V70del,G339D,S371L,S373P,S375F,K417N,N440K,G446S,S477N,T478K,E484A,Q493R,G496S,Q498R,N501Y,Y505H,D614G,P681H,D796Y);N(P13L)', info: '新变异株，具有比Delta株更强的传播性和比Beta株更强的免疫逃逸性。目前主要流行于南非、美国' }
  ],

  arrLang: {
    'virus-analysis-platform': ['Virus analysis platform', '病毒检测分析平台'],
    'virus-molecular-network-report': ['Virus molecular network report', '病毒分析报告'],
    'report-description': ['The analysis including typing, transmission and TRACE was performed on Virus sequence from samples. Part 1 shows the mutation distrubition among the samples；Part 2 is the typing result of input sequences; Part 3 construct the molecular transmission clusters, which identify chains of partners whose viral genetic relatedness imply direct or indirect epidemiological connections; Part4 discribes the relationship between variation speed and time; The last part reports the transmitting path and the phylogenetic relationships among these sequences.',
      '本报告对样本中基于测序得到序列，通过生物信息学分析，对测序结果进行测序质量评估、病毒基因组组装、突变检测及其在基因组上的分布、病毒分型和进化树分析。第一部分是对测序数据的质量评估；第二部分是对组装结果的质量统计和突变位点分布分析；第三部分是组装得到的序列的分型结果展示；第四部分展示序列与核心库序列的系统发育关系。'],
    'sequencing-quality-assessment': ['Sequencing quality assessment', '测序质量评估'],
    'depth-of-sequencing': ['Depth of Sequencing', '测序深度统计'],
    'frequency-of-depth': ['Frequency of Depth', '测序深度频率统计'],
    'sequencing-assembly': ['Sequencing Assembly', '序列组装'],
    'download': ['Download', '下载'],
    'mutation-distribution': ['Mutation Distribution', '突变位点分布'],
    'classification-results': ['Classification results', 'Blast结果'],
    'blast-database': ['Blast database: ', 'Blast序列库'],
    'download-tabular-file': ['DownloadTabularFile', '下载Tabular'],
    'download-asn-file': ['DownloadAsnFile', '下载Asn'],
    'genotype-results': ['Genotype results', '重组分析结果'],
    'typing-result': ['Typing results', '分型结果'],
    'phylogenetic-tree-results': ['Phylogenetic tree results', '进化树结果'],
    'drug-resistance-results': ['Drug resistance results', '耐药分析结果'],
    'trace-results': ['Trace results', 'Trace分析结果'],
    'trace-description-1': ['TRACE is a computational tool for identifying a molecular transmission analog of such clusters. ',
      'TRACE is a computational tool for identifying a molecular transmission analog of such clusters. '],
    'trace-description-2': ['TRACE implements an approach inspired by traditional epidemiology, by identifying chains of partners whose viral genetic relatedness imply direct or indirect epidemiological connections. Molecular transmission clusters are constructed using codon-aware pairwise alignment to a reference sequence followed by pairwise genetic distance estimation among all sequences. It\'s able to monitor the existing and ongoing virus transmission and take intervention measures on the identified active transmission network by combining the molecular clusters and social network, which is helpful to control the spread of virus.',
      'TRACE implements an approach inspired by traditional epidemiology, by identifying chains of partners whose viral genetic relatedness imply direct or indirect epidemiological connections. Molecular transmission clusters are constructed using codon-aware pairwise alignment to a reference sequence followed by pairwise genetic distance estimation among all sequences. It\'s able to monitor the existing and ongoing virus transmission and take intervention measures on the identified active transmission network by combining the molecular clusters and social network, which is helpful to control the spread of virus.'],
    'temporal-rate': ['Temporal rate', '进化速率结果'],
    'transmission': ['Transmission', '传播路径结果'],
    'protein-conformation-results': ['Protein conformation', '蛋白构象结果'],
    'resistance-results': ['Resistance results', '耐药分析结果'],
    'virulence-results': ['Resistance results', '毒力分析结果'],
    'antigenic-drift-results': ['Resistance results', '免疫逃逸结果']
  },

  _covid19_gene_info: [
    // {name:'ORF1a', start:265, end:13468},
    // {name:'ORF1b', start:13467, end:21555},
    // {name:'S', start:21562, end:25384},
    // {name:'ORF3a', start:25392, end:26220},
    // {name:'E', start:26244, end:26472},
    // {name:'M', start:26522, end:27191},
    // {name:'ORF6', start:27201, end:27387},
    // {name:'ORF7a', start:27393, end:27759},
    // {name:'ORF7b', start:27755, end:27887},
    // {name:'ORF8', start:27893, end:28259},
    // {name:'ORF9b', start:28283, end:28577},
    // {name:'N', start:28273, end:29533}
    { name: 'ORF1a', start: 266, end: 13482, color: '#8EBC66' },
    { name: 'ORF1b', start: 13483, end: 21554, color: '#E59637' },
    { name: 'S', start: 21563, end: 25384, color: '#5097BA' },
    { name: 'ORF3a', start: 25393, end: 26220, color: '#AABD52' },
    { name: 'E', start: 26245, end: 26472, color: '#D9AD3D' },
    { name: 'M', start: 26523, end: 27191, color: '#5097BA' },
    { name: 'ORF6', start: 27202, end: 27387, color: '#DF4327' },
    { name: 'ORF7a', start: 27394, end: 27756, color: '#C4B945' },
    { name: 'ORF7b', start: 27756, end: 27887, color: '#75B681' },
    { name: 'ORF8', start: 27894, end: 28259, color: '#60AA9E' },
    { name: 'N', start: 28274, end: 29533, color: '#E67030' },
    { name: 'ORF10', start: 29558, end: 29674, color: '#D9AD3D' }
  ],

  doNumber (x, n) {
    var fx = parseFloat(x)
    if (isNaN(fx)) {
      console.log('function:changeTwoDecimal->parameter error')
      return x
    }
    if (n <= 0) {
      return parseInt(x)
    }
    let pown = Math.pow(10, n)
    var f = Math.round(x * pown) / (pown)
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + n) {
      s += '0'
    }
    return s
  },

  formatFastpResult (jsonData, integerReservation = 6, decimalReservation = 2) {
    if (jsonData === undefined || jsonData === null) return

    let isPairedEnd = jsonData['read2_before_filtering'] !== undefined
    let colorArray = {
      'A': 'rgba(128,128,0,1.0)',
      'C': 'rgba(0,255,0,1.0)',
      'T': 'rgba(128,0,128,1.0)',
      'G': 'rgba(0,0,255,1.0)',
      'N': 'rgba(255, 0, 0, 1.0)',
      'GC': 'rgba(20,20,20,1.0)',
      'mean': 'rgba(20,20,20,1.0)'
    }
    let _getFormatData = function (xlen, ydata, colorArray) {
      let xdata = []
      for (let i = 1; i <= xlen; i++) {
        xdata.push(i)
      }
      let formatData = []
      for (let key in ydata) {
        formatData.push({
          x: xdata,
          y: ydata[key],
          name: key,
          mode: 'line',
          line: { color: colorArray[key], width: 1 }
        })
      }
      return formatData
    }
    let data = {
      'general': {
        'sequencing': isPairedEnd ? 'paired end (' + jsonData['read1_before_filtering']['total_cycles'] + ' cycles + ' + jsonData['read2_before_filtering']['total_cycles'] + ' cycles)'
          : 'single end (' + jsonData['read1_before_filtering']['total_cycles'] + ' cycles)',
        'meanLengthBeforeFiltering': jsonData['summary']['before_filtering']['read1_mean_length'] + 'bp' + (isPairedEnd ? ', ' + jsonData['summary']['before_filtering']['read2_mean_length'] + 'bp' : ''),
        'meanLengthAfterFiltering': jsonData['summary']['after_filtering']['read1_mean_length'] + 'bp' + (isPairedEnd ? ', ' + jsonData['summary']['after_filtering']['read2_mean_length'] + 'bp' : ''),
        'duplicationRate': (jsonData['duplication']['rate'] * 100).toFixed(decimalReservation) + '%',
        'insertSizePeak': isPairedEnd ? jsonData['insert_size']['peak'] : undefined,
        'adapterCutting': isPairedEnd ? undefined : (jsonData['adapter_cutting'] === undefined ? 'none' : jsonData['adapter_cutting']['read1_adapter_sequence']),
        'beforeFiltering': {
          'total_reads': this.doNumber(jsonData['summary']['before_filtering']['total_reads'] / 1000.0, integerReservation) + ' K',
          'total_bases': this.doNumber(jsonData['summary']['before_filtering']['total_bases'] / 1000000.0, integerReservation) + ' M',
          'q20_bases': this.doNumber(jsonData['summary']['before_filtering']['q20_bases'] / 1000000.0, integerReservation) + ' M ' +
            '(' + (jsonData['summary']['before_filtering']['q20_rate'] * 100).toFixed(decimalReservation) + '%)',
          'q30_bases': this.doNumber(jsonData['summary']['before_filtering']['q30_bases'] / 1000000.0, integerReservation) + ' M ' +
            '(' + (jsonData['summary']['before_filtering']['q30_rate'] * 100).toFixed(decimalReservation) + '%)',
          'gc_content': (jsonData['summary']['before_filtering']['gc_content'] * 100).toFixed(decimalReservation) + '%'
        },
        'afterFiltering': {
          'total_reads': this.doNumber(jsonData['summary']['after_filtering']['total_reads'] / 1000.0, integerReservation) + ' K',
          'total_bases': this.doNumber(jsonData['summary']['after_filtering']['total_bases'] / 1000000.0, integerReservation) + ' M',
          'q20_bases': this.doNumber(jsonData['summary']['after_filtering']['q20_bases'] / 1000000.0, integerReservation) + ' M ' +
            '(' + (jsonData['summary']['after_filtering']['q20_rate'] * 100).toFixed(decimalReservation) + '%)',
          'q30_bases': this.doNumber(jsonData['summary']['after_filtering']['q30_bases'] / 1000000.0, integerReservation) + ' M ' +
            '(' + (jsonData['summary']['after_filtering']['q30_rate'] * 100).toFixed(decimalReservation) + '%)',
          'gc_content': (jsonData['summary']['after_filtering']['gc_content'] * 100).toFixed(decimalReservation) + '%'
        }
      },
      'graph': {
        'read1': {
          'beforeFiltering': {
            'quality': _getFormatData(jsonData['read1_before_filtering']['total_cycles'], jsonData['read1_before_filtering']['quality_curves'], colorArray),
            'base': _getFormatData(jsonData['read1_before_filtering']['total_cycles'], jsonData['read1_before_filtering']['content_curves'], colorArray)
          },
          'afterFiltering': {
            'quality': _getFormatData(jsonData['read1_after_filtering']['total_cycles'], jsonData['read1_after_filtering']['quality_curves'], colorArray),
            'base': _getFormatData(jsonData['read1_after_filtering']['total_cycles'], jsonData['read1_after_filtering']['content_curves'], colorArray)
          }
        },
        'read2': isPairedEnd ? {
          'beforeFiltering': {
            'quality': _getFormatData(jsonData['read2_before_filtering']['total_cycles'], jsonData['read2_before_filtering']['quality_curves'], colorArray),
            'base': _getFormatData(jsonData['read2_before_filtering']['total_cycles'], jsonData['read2_before_filtering']['content_curves'], colorArray)
          },
          'afterFiltering': {
            'quality': _getFormatData(jsonData['read2_after_filtering']['total_cycles'], jsonData['read2_after_filtering']['quality_curves'], colorArray),
            'base': _getFormatData(jsonData['read2_after_filtering']['total_cycles'], jsonData['read2_after_filtering']['content_curves'], colorArray)
          }
        } : undefined
      }
    }
    return data
  },

  _downloadFile (text, fileName) {
    let element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', fileName)
    element.style.display = 'none'
    element.click()
  }
}



// WEBPACK FOOTER //
// ./src/utils/report.js